import { Editor } from '@monaco-editor/react'
import { RJSFSchema } from '@rjsf/utils'
import { getSampleRegistrationUiSchema } from '../../schemas/schema-utils'
import { useEffect, useState } from 'react'

type SchemaUiEditorProps = {
  schema: RJSFSchema | undefined
}

export const SchemaUiEditor = ({ schema }: SchemaUiEditorProps) => {
  const [prefersDarkMode, setPrefersDarkMode] = useState(
    globalThis.matchMedia('(prefers-color-scheme: dark)').matches
  )
  useEffect(() => {
    const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (event: MediaQueryListEvent) =>
      setPrefersDarkMode(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])
  const theme = prefersDarkMode ? 'vs-dark' : 'light'

  const uiSchema = getSampleRegistrationUiSchema(schema, false)
  const stringifiedUiSchema = JSON.stringify(
    uiSchema,
    (_key, value) => {
      if (typeof value === 'function') {
        return value.name && value.name.length > 0
          ? value.name
          : 'anonymous-function'
      }
      return value
    },
    2
  )

  return (
    <Editor
      theme={theme}
      height='30vh'
      defaultLanguage='json'
      value={stringifiedUiSchema}
      options={{
        minimap: { enabled: false },
        automaticLayout: true,
        readOnly: true
      }}
    />
  )
}
